import React, { useState, useEffect, useRef } from "react";
import Loadable from "react-loadable";
import homeCar from "../../Assets/newAsset/lpassets/homeCar.svg";
import logoWhite from "../../Assets/newAsset/lpassets/clearFooter.svg";
import ringImg from "../../Assets/newAsset/lpassets/newAssets/W_LP_new/ring.svg";
// import LpFormDisplay from "../LandingPages/Component/LpFormDisplay";
//  import {LInk} from "react-router-dom"
import blurr from "../../Assets/newAsset/lpassets/newAssets/W_LP_new/Ellipse524.svg";
import { FiPhone, FiMail } from "react-icons/fi";
import { useLocation, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/Loader/Loader";
// import Content from "../homePage/Components/Content";
import LpForm from "./LpForm";
import "./Adlp.css";
import LpActions from "../LandingPages/LpActions";
import { connect } from "react-redux";
// import SamProf from "../../Assets/newAsset/imaging/sam.webp";
import Scooter from "../../Assets/newAsset/lpassets/newAssets/W_LP_new/scooter.svg";
import { TopsellingDiv } from "./TopSelling";
// import transparentLOGO from "../../Assets/newAsset/lpassets/newAssets/newBanner/logo-transparent.png";
// import Eclipse from "../../Assets/newAsset/lpassets/newAssets/newBanner/ecliplse.png";
// import FaqAccorComponent from "../homePage/FaqAccorComponent";
// import ScrolltoTop from "../../components/Scrolltotop/ScrolltoTop";
// import Featured from "../homePage/Components/Featured";
// import Apointment from "../homePage/Components/Apointment";
//IMPORTING ACTIONS FOR REEDUX API CALL
import { getCity } from "../../Redux/Actions";
import { Modal } from "react-responsive-modal";
import Popup from "../../components/PopupNotification/LpPopup";

const scrollTop = () => {
  window.scroll({
    top: 340,
    left: 0,
    behavior: "smooth",
  });
};

const stepsData = [
  {
    id: 1,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/245666fd-7e57-4dae-90bb-a8381ac0da59.webp",
    desc: "Temperature Checks",
  },
  {
    id: 2,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/5aa857e6-ec25-48f9-a86d-7de73342fa20.webp",
    desc: "Secure Packaging",
  },
  {
    id: 3,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac00e3ea-c6c1-4432-8a67-1260075a892f.webp",
    desc: "Stored Safely",
  },
  {
    id: 4,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/84cad4f1-ba4e-40ec-8380-10e1e2223ba8.webp",
    desc: "Regular Sanitization",
  },
  {
    id: 5,
    img:
      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/0b9d508f-c135-4ccb-a61c-d73cd7f25c0a.webp",
    desc: "No Contact Delivery",
  },
];
//FAQ's Data//

const FAQ = [
  {
    question: "What is included in a full body checkup?",
    answer:
      "A full-body health checkup consists of various tests including Thyroid Profile Test, Complete Hemogram Test, Kidney Function Test, Lipid Profile Test, Liver Function Test, Urine Routine Test, Blood Glucose Test, and others.",
  },
  {
    question: "Which complete body checkup is best?",
    answer: {
      faq:
        "Redcliffe's complete body health check is a comprehensive health checkup package that helps in the diagnosis of all the organs and bodily functioning systems. Some of the popular full body packages that help in the complete assessment of organs are:",
      list: [
        "LFT - Liver Function Tests with GGT",
        "KFT - Kidney Function Tests",
        "CBC - Complete Hemogram",
        "Electrolytes Profile",
        "Calcium, Phosphorus & ALP",
        "ESR, Uric Acid and Protein, and others",
      ],
    },
  },
  {
    question: "How much is the full body checkup price?",
    answer: {
      faq:
        "Redcliffe Labs offers health checkup packages starting from as low as Rs. 699. Depending upon your medical needs and health requirements, you can pick from our health checkup packages like:",
      list: [
        "Redcliffe Advance Full Body Checkup – Male",
        "Redcliffe Advance Full Body Checkup – Female",
        "Redcliffe Advance Full Body Checkup",
        "Redcliffe Advance Plus Full Body Checkup",
        "Redcliffe Smart Plus Full Body Checkup",
      ],
    },
  },
  {
    question: "How many tests are covered in a full body checkup?",
    answer: {
      faq:
        "Redcliffe offers Full body checkups starting at only Rs. 699. A whole-body checkup includes a combination of general and additional tests such as:",
      list: [
        "General tests:",
        "Urine Routine Analysis",
        "Stool Test (Optional)",
        "Additional tests",
        "Thyroid Stimulating Hormone (TSH)",
        "HbsAg",
        "Serum Phosphorus",
        "PSA (for Men) and others",
      ],
    },
  },
  {
    question: "How long does a full-body checkup take?",
    answer:
      "The blood sample collection timing for a full body check-up takes a few minutes. The sample is then sent to the laboratories for analysis and examination.",
  },
  {
    question: "Why Choose Full Body Checkup from Redcliffe Labs?",
    answer:
      "Redcliffe Labs is a diagnostic lab that offers an expansive range of Full Body Checkup Health Packages according to patients’ needs and medical conditions. We are best known for our advanced technology and state-of-the-art infrastructure with affordable health checkup packages.Redcliffe Labs is well equipped with all the advanced medical tools and accessories. We make sure that every test performed at our centre should fetch the most reliable and best results possible. Our diagnostic care meets all the global healthcare standards offering a secure environment to the patients. Also, the full-body checkup cost at Redcliffe Labs is affordable.",
  },
  {
    question: "How often should I do a body check-up?",
    answer:
      "How often one should get a body checkup done, depends on the family history of patients, their age, and sex and lifestyle habits. Going by the advice of the medical experts at Redcliffe Labs, routine health checkups should be done at least once a year for patients over the age of 50 or above and once every 2-3 years for people younger than 50. The requirement or the need for the tests may vary depending upon certain medical conditions and chronic diseases, regardless of age.",
  },
  {
    question: "Do healthy people also require full-body checkups frequently? ",
    answer:
      "Medical experts at Redcliffe recommend undergoing full-body checkups yearly for every individual no matter if the person is healthy or not. But there are professionals who suggest going for a selective approach for averting any disease. It means healthy people don’t have to undergo full-body check ups yearly. So, it entirely depends from person to person, doctor to doctor. We recommend visiting the full-body checkup centres once a year at least to ensure improved health.",
  },
  {
    question: " Is full body check-up good?",
    answer:
      " Regular Full Body Checkup is important for our health for a variety of reasons. The sudden inexplicable health concerns call for the immediate medical intervention of an expert. Regular complete body checkup is important to keep your health in top order by timely assessing your general health with regular health checks for early detection of certain diseases and illnesses.Health checks on time-to-time benefits in promoting better and improved health. Doctors at our centre also educate the patients to lead a healthy life and how they can include healthy habits in their routine.",
  },
  {
    question: "What is included in a whole body checkup?",
    answer: {
      faq: "The tests list of Full Body Checkup includes:",
      list: [
        "Liver Function Test",
        "Thyroid Profile: TSH, T3, T4 ",
        "Kidney Function Test: Uric Acid, Serum Creatinine, Blood Urea",
        "Hb1AC",
        "Blood and Urine tests",
        "Hepatitis B test",
      ],
    },
  },
];

// const FAQCovid = [
//   {
//     id: 1,
//     question: "Who should get tested for COVID-19 test? ",
//     answer:
//       "If someone is having symptoms of an infected respiratory tract, including a persistent cough, sore throat, shortness of breath and fever, that would definitely be a clear sign to go in and get your COVID-19 test done. Also, it is important to get your COVID-19 test done if you think you have come in contact with a confirmed case of a coronavirus patient. .",
//   },
//   {
//     id: 2,
//     question: "What are the common symptoms of COVID-19 infection?",
//     answer:
//       "The most common symptoms of coronavirus disease are dry cough, fatigue, body ache and fever. Some patients may experience more severe forms of the disease, like pneumonia. The best way to confirm if you have caught the virus producing COVID-19 disease is with a COVID-19 laboratory test.",
//   },
//   {
//     id: 3,
//     question:
//       "Is it important to get my family members tested for COVID-19 if the doctor has prescribed for my RT-PCR test?",
//     answer:
//       "It is important and safe to get your COVID-19 test done if you have come in close contact with an infected person even if the person is your family member. In the meantime, you and your family members should take necessary precautions such as wearing a mask, proper sanitization, washing your hands for at least 20 seconds and following all safety and hygiene measures.",
//   },
//   {
//     id: 4,
//     question: "How to book covid-19 test?",
//     answer:
//       "Booking a COVID-19 test is easy. You need to visit our website redcliffelabs.com and fill in your details. Our customer service will contact you for home sample collection. To book your COVID-19 test, contact us at 898 898 8787.",
//   },
//   {
//     id: 5,
//     question:
//       "After booking COVID-19 test at Redcliffe Labs, when will I visit the centre for the test?",
//     answer:
//       "We understand the importance of lives and the intricacies of this pandemic situation. We thus recommend patients to get their tests done safely at their home. We are providing our patients with the sample home collection service by our expert Phlebotomists. For home collection, you can book your appointment for COVID-19 test at http://redcliffelabs.com/ or by calling us at 898 898 8787.",
//   },
//   {
//     id: 6,
//     question: "How can i know if i had covid-19 in past?",
//     answer:
//       "Whether someone has had covid infection in the past, we at Redcliffe Labs provide our patients with Covid Antibody Test. These tests are usually done via blood samples. Covid Antibody tests are not done to detect covid but it is done to detect whether or not you have had covid infection in the past.",
//   },
//   {
//     id: 7,
//     question: "Is it safe to get my test done at home?",
//     answer:
//       "At Redcliffe Labs, we have a proficient team of Phlebotomists who are trained to follow all safety measures needed for COVID–19 home sample collection. To ensure safety, our Phlebotomists wear Disposable (single use) Personal Protective Equipment (PPE) consisting of gloves, N95 mask, goggles, face shield, hair cover and shoe cover. Once the sample is collected, they dispose of the PPE kit worn during sample collection.",
//   },
//   {
//     id: 8,
//     question: "How long does it take to get COVID-19 test results?",
//     answer:
//       "It usually takes 24-48 hours to get the COVID-19 test report from the time of sample collection.",
//   },
//   {
//     id: 9,
//     question:
//       "What is the current testing method used at Redcliffe Labs?",
//     answer:
//       "At present, RT-PCR test is recommended to detect the presence of COVID-19 virus. COVID Antibody tests are also being done at our labs to ascertain if someone has had coronavirus in the past.",
//   },
//   {
//     id: 10,
//     question: "What if I am tested positive for COVID?",
//     answer:
//       "If you test positive, try to isolate yourself to prevent others from getting sick. Get in touch with your doctor for further medical assistance. If you test negative, you probably were not infected at the time of sample collection.",
//   },
// ];

//NEW CARDS DATA

import "./Newlp.css";

// import ErrorPage from "../ErrorPage";

//why choose us
export const WhyChooseUs = () => {
  return (
    <div className=" WhyChooseUs">
      <div className=" whyUscontainer">
        <h3>Why Choose Us?</h3>
        <div className=" Four_div_box">
          <div className=" For_Image_And_text">
            <div className=" WhyChooseUslogo">
              <img
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ae34b20a-80ce-4813-b2e8-e1afb4731f53.webp"
                }
                alt="Assured Safety"
              />
            </div>
            <p className=" whyChooseUspara"> Assured Safety</p>
          </div>
          <div className=" For_Image_And_text">
            <div className=" WhyChooseUslogo">
              <img
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-images/None/6e9c830a-513d-4477-a405-61abc9e94187.webp"
                }
                alt="Certified Labs"
              />
            </div>
            <p className=" whyChooseUspara"> Certified Labs</p>
          </div>
          <div className=" For_Image_And_text">
            <div className=" WhyChooseUslogo">
              <img
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-images/None/d790df8a-dc9c-4355-bd73-4b4d81821382.webp"
                }
                alt="Free Sample Pick-Up"
              />
            </div>
            <p className=" whyChooseUspara">Free Sample Pick-Up</p>
          </div>
          <div className=" For_Image_And_text">
            <div className=" WhyChooseUslogo">
              <img
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-images/None/02f40e8a-d0ff-41de-bdea-4f69968c0ae0.webp"
                }
                alt="Accurate Reports"
              />
            </div>
            <p className=" whyChooseUspara"> Accurate Reports</p>
          </div>
        </div>
        <div className=" forBackgroundcolor">{/* Blank */}</div>
      </div>
    </div>
  );
};

function Adlp(props) {
  // console.log(props, "Here is props");
  // useEffect(() => {
  //   props?.getLppackageDetails(pacakgeNameFromUrl)
  // }, [])

  // let packDetail = props?.package.length > 0  ? props?.package[0] : {}
  // console.log("packdetails" , packDetail)

  //calling city name api

  const Featured = Loadable({
    loader: () => import("../homePage/Components/Featured"),
    loading: Loader,
  });

  const Apointment = Loadable({
    loader: () => import("../homePage/Components/Apointment"),
    loading: Loader,
  });

  // const Content = Loadable({
  //   loader: () => import('../homePage/Components/Content'),
  //   loading: Loader,
  // });

  const ScrolltoTop = Loadable({
    loader: () => import("../../components/Scrolltotop/ScrolltoTop"),
    loading: Loader,
  });

  // const LpForm = Loadable({
  //   loader: () => import('./LpForm'),
  //   loading: Loader,
  // });

  const FaqAccorComponent = Loadable({
    loader: () => import("../homePage/FaqAccorComponent"),
    loading: Loader,
  });

  const ErrorPage = Loadable({
    loader: () => import("../ErrorPage"),
    loading: Loader,
  });

  useEffect(() => {
    dispatch(getCity());
  }, []);

  const dispatch = useDispatch();
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE

  //form page details
  const [userName, setUserName] = useState("");
  const [userNumber, setUserNumber] = useState("");
  const [nameError, setNameEror] = useState("");
  const [phoneError, setPhoneEror] = useState("");
  const [footerTel, setTelNum] = useState("");
  const [disable, setDisable] = useState(true);
  const [open1, setOpen1] = useState(false);
  const onOpenModal1 = () => setOpen1(true);
  const onCloseModal1 = () => setOpen1(false);

  //validation on submit button
  useEffect(() => {
    if (userName == "" || userNumber == "") {
      setDisable(true);
      console.log("inside if");
    } else {
      setDisable(false);
      console.log("inside else");
    }
  }, [userName, userNumber]);

  const location = useLocation();

  const params = useParams();

  //GETTING PACKAGE DETAILS FROM STORE
  // const packageDetails = useSelector((state) => state.packageDetails);
  // const { loading, packDetail, error } = packageDetails;

  var url = `https://redcliffelabs.com${location.pathname}/bottom${location.search}`;

  const pacakgeNameFromUrl = params.slug;

  const [successBtn, setSuccessBtn] = useState(false);
  //CALLING PACAKGE DETAILS  API
  useEffect(() => {
    props.getLppackageDetails(pacakgeNameFromUrl);
  }, [pacakgeNameFromUrl]);

  let packDetail = props?.package;

  useEffect(() => {
    if (location.pathname.includes("/lp2/")) {
      setTelNum("898 898 8585");
    } else if (location.pathname.includes("/lp/fb/")) {
      setTelNum("898 898 9393");
    } else if (location.pathname.includes("/lp/sms/")) {
      setTelNum("931 126 1990");
    } else if (location.pathname.includes("/lp/")) {
      setTelNum("898 898 8585");
    }
  }, []);

  const [lpImage, setlpImage] = useState(false);

  useEffect(() => {
    if (location.pathname.includes("lp2/antenatal-test")) {
      setlpImage(true);
    } else if (location.pathname.includes("lp2/cancer-screening-female")) {
      setlpImage(true);
    } else if (location.pathname.includes("lp2/women-smart-health-package")) {
      setlpImage(true);
    } else if (packDetail.recommended_gender == "female") {
      setlpImage(true);
    } else {
      setlpImage(false);
    }
  });

  const callRecieve = useSelector((state) => state.callRecieve);
  const { success } = callRecieve;

  const handelUserName = (e) => {
    setUserName(e.target.value);
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameEror("");
    if (!e.target.value.match(characterRegex)) {
      setNameEror("invalid user name");
    }
    if (e.target.value == "") {
      setNameEror("");
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 2
  const validatePhoneNumber = () => {
    let phoneno = /^\d{10}$/;
    if (!userNumber.match(phoneno) || parseInt(userNumber[0]) < 6) {
      setPhoneEror("Enter a valid number*");
      return false;
    } else {
      return true;
    }
  };
  //HANDEL USEPHONE FUNCTION BELOW THIS COMMENT 1
  const handelPhoneChange = (e) => {
    setUserNumber(e.target.value);
    setPhoneEror("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    const checkVal = validatePhoneNumber();

    if (checkVal) {
      const body = {
        name: userName,
        phone_no: userNumber,
        source: "Ecommerce",
        city: "",
        url,
      };

      setUserNumber("");
      setUserName("");
      setSuccessBtn(true);
      setTimeout(() => {
        setSuccessBtn(false);
      }, 2000);
      setPhoneEror("");
      props.getCall(body);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      onOpenModal1();
    }, 60000);
  }, []);

  const inputFocusDiv = useRef();

  return props.loading ? (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Loader />
    </div>
  ) : props?.package.length == 0 ? (
    <div className=" errorDIVNo">
      <ErrorPage />
      <div className=" footerLp">
        <div className=" footerContainer">
          <div className=" footerFirstRow">
            <div className=" logoIMg">
              <img
                width="100%"
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                alt={logoWhite}
              ></img>
            </div>
            <div className=" footerDesc">
              <p>
                Redcliffe Labs is an accredited advanced diagnostic laboratory
                that aims at providing top-notch consistent and accurate
                laboratory services with modern technology and equipment all
                inclusive of logistics management.
              </p>
            </div>
          </div>
          <div className=" footerSecondRow">
            <div className=" footerLogo">
              <span>Contact Us</span>
              <div className=" emailLogo">
                <span>
                  <FiMail />
                </span>
                care@redcliffelabs.com
              </div>
              <a href={`tel:+91${footerTel}`}>
                <div className=" phoneLogo">
                  <span>
                    <FiPhone />
                  </span>
                  {footerTel}
                </div>
              </a>
            </div>
          </div>
          <div className=" borderDiv"></div>
          <div className=" footerThirdRow">
            <div className=" footerMsg">
              <p>
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
              <p>
                Redcliffe Labs <br /> © 2022. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="adlp">
      <div className=" NewlpBackground">
        {/* <div className=" newMobileBackground">
        <div className=" redLogos_milinTest">
          <div className=" leftSide_lp">
            <img
              width="100%"
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
              alt="transparentLOGO}"
            />
          </div>
          <div className=" rightSide_lp">
            <div className=" top__bar">
              <p>No.1 Diagnostics Lab for me & my family!</p>
            </div>
            <div className=" bottom__bar">
              <span>~Milind Soman</span>
            </div>
          </div>
        </div>
        <div className=" milindImages_new">
          <img
            width="100%"
            src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/58e6f495-3471-47a5-bcfd-2ff6aa0d3094.png"
            alt="profile-img"
            className=" bannerImg_newLP"
          />
          <img
            width="100%"
            src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/1e7366d6-2d04-409e-bd59-3c785f0595ab.png"
            alt="eclipse"
            className=" eclipse"
          />
          {packDetail && packDetail.name ? (
            <p className=" mainTagHeadingMobile">{packDetail.name}</p>
          ) : null}
        </div>
      </div> */}

        <div className=" lpContainerNew">
          <div className=" left_sideLpnew  ">
            <div className=" newBrand">
              <img
                width="100%"
                src={
                  "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                }
                alt={
                  "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                }
              ></img>
            </div>
            <div className=" left_625px_New_Adlp2  left_625px_restore">
              <img src={ringImg} alt={ringImg} className="ring" />
              <img src={blurr} alt={ringImg} className="bblurr" />
              <img
                src={
                  lpImage
                    ? "https://staticcdn.redcliffelabs.com/media/gallary-file/None/586240d7-a840-47db-8538-d06eaa5bc41c.webp"
                    : "https://staticcdn.redcliffelabs.com/media/gallary-file/None/2d61ce31-3f00-4c63-b14b-d172e7ec8298.webp"
                }
                alt="profileimg"
                width="100%"
                height="100%"
              />
            </div>
          </div>
          <div className=" right_sideLpnew  ">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/69780ca3-4abe-4f88-a130-7a1f182ec0bd.webp"
              className=" whitebanner"
            />
            <div className=" right_625px  ">
              {/* {packDetail && packDetail.name ? (
                <p className=" lpmainTagHeading">{packDetail.name}</p>
              ) : null} */}

              {packDetail && packDetail.name ? (
                <p className="lpmainTagHeading">
                  {" "}
                  {packDetail?.name.includes("Checkup") ? (
                    <p style={{ color: "#e5184e" }}>
                      {packDetail?.name.replace("Checkup", " ")}{" "}
                      <span style={{ fontWeight: "700", color: "#0e416b" }}>
                        Checkup
                      </span>
                    </p>
                  ) : (
                    packDetail?.name
                  )}
                </p>
              ) : null}

              <div className=" priceTag">
                <span style={{ fontSize: "2.5rem" }}>
                  Rs. &nbsp;
                  <span style={{ textDecoration: "line-through" }}>
                    {packDetail?.package_city_prices
                      ? packDetail?.package_city_prices?.package_price
                      : packDetail?.package_price}
                  </span>
                </span>
                <span style={{ fontSize: "3rem", fontWeight: "700" }}>
                  @Rs.&nbsp;
                  {packDetail && packDetail.offer_price
                    ? packDetail.offer_price
                    : null}
                </span>
              </div>
              <div className=" scooterDiv">
                <span className=" test_included">
                  {packDetail && packDetail.parameter
                    ? packDetail.parameter
                    : null}{" "}
                  {packDetail?.parameter == 1
                    ? "test only"
                    : "tests  included "}
                </span>

                <span className=" freHome">
                  FREE Home Sample Collection{" "}
                  <img src={Scooter} width="90px" alt="scooter" />{" "}
                </span>
              </div>
              <div className=" NewlpParameters">
                <h5>Test Parameters</h5>

                <p className=" parameterFont">
                  Now with{" "}
                  {packDetail && packDetail.parameter
                    ? packDetail.parameter
                    : null}{" "}
                  {packDetail?.parameter == 1
                    ? "test only"
                    : "tests which includes "}
                </p>

                {/**description */}

                <p className=" paraDesc">
                  {packDetail && packDetail.description
                    ? packDetail.description
                    : null}
                </p>
              </div>

              <div className="lpNewForm_final fft">
                <LpForm
                  focus={inputFocusDiv}
                  isLp={true}
                  butname={"SUBMIT"}
                  buttonId={"LpTop"}
                  formId={"LpForm"}
                  lpNumber={footerTel}
                  position={"Top"}
                  push={true}
                />
              </div>
            </div>
          </div>
        </div>

        <div className=" newCardslp lpCard1024">
          <div className=" NewlpDivRow">
            {packDetail?.tat_time ? (
              <div className=" lpcards">
                <div className=" card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ac337b36-2d09-4dff-81e9-4de9ad5e805e.webp"
                    }
                    width="100%"
                  />
                </div>
                <div className=" card__contentlp">
                  <span className=" mainHeading">Get Reports in</span>
                  <span className=" redHeading">{packDetail?.tat_time}</span>
                </div>
              </div>
            ) : null}
            {packDetail && packDetail.fasting_time ? (
              <div className=" lpcards">
                <div className=" card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                    }
                    width="100%"
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/9744cfba-3b7d-478e-b33d-cb4a82a2404b.webp"
                    }
                  />
                </div>
                <div className=" card__contentlp">
                  <span className=" mainHeading"> Fasting Requirement</span>
                  <span className=" redHeading">{packDetail.fasting_time}</span>
                </div>
              </div>
            ) : null}
            {/**sample information */}
            {packDetail && packDetail.sample ? (
              <div className=" lpcards">
                <div className=" card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                    }
                    width="100%"
                  />
                </div>
                <div className=" card__contentlp">
                  <span className=" mainHeading">Sample Collection</span>
                  <span className=" redHeading">{packDetail.sample}</span>
                </div>
              </div>
            ) : null}

            {/**Home collection packDetail.home_collection */}
            {packDetail && packDetail.home_collection ? (
              <div className=" lpcards">
                <div className=" card__imglp">
                  <img width="100%" src={homeCar} />
                </div>
                <div className=" card__contentlp">
                  <span className=" mainHeading">Home Collection</span>
                  <span className=" redHeading">Available</span>
                </div>
              </div>
            ) : null}

            {packDetail && packDetail.recommended_age ? (
              <div className=" lpcards">
                <div className=" card__imglp">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                    }
                    alt={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/94275e49-7aaf-4718-ae5c-02564223b533.webp"
                    }
                    width="100%"
                  />
                </div>
                <div className=" card__contentlp">
                  <span className=" mainHeading">Age Group</span>
                  <span className=" redHeading">
                    {packDetail.recommended_age} years
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <TopsellingDiv
          focus={inputFocusDiv}
          title="Our Most Booked Packages"
          footerTel={footerTel}
        />
        {/*** wHY CHOOSE US */}

        <div className=" WhyChooseUs">
          <div className=" whyUscontainer">
            <h3>Why Choose Us?</h3>
            <div className=" Four_div_box">
              <div className=" For_Image_And_text">
                <div className=" WhyChooseUslogo">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/ae34b20a-80ce-4813-b2e8-e1afb4731f53.webp"
                    }
                    alt="Assured Safety"
                    width="100%"
                  />
                </div>
                <p className=" whyChooseUspara"> Assured Safety</p>
              </div>
              <div className=" For_Image_And_text">
                <div className=" WhyChooseUslogo">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/6e9c830a-513d-4477-a405-61abc9e94187.webp"
                    }
                    alt="Certified Labs"
                    width="100%"
                  />
                </div>
                <p className=" whyChooseUspara"> Certified Labs</p>
              </div>
              <div className=" For_Image_And_text">
                <div className=" WhyChooseUslogo">
                  <img
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/d790df8a-dc9c-4355-bd73-4b4d81821382.webp"
                    }
                    width="100%"
                    alt="Free Sample Pick-Up"
                  />
                </div>
                <p className=" whyChooseUspara">Free Sample Pick-Up</p>
              </div>
              <div className=" For_Image_And_text">
                <div className=" WhyChooseUslogo">
                  <img
                    width="100%"
                    src={
                      "https://staticcdn.redcliffelabs.com/media/gallary-images/None/02f40e8a-d0ff-41de-bdea-4f69968c0ae0.webp"
                    }
                    alt="Accurate Reports"
                  />
                </div>
                <p className=" whyChooseUspara"> Accurate Reports</p>
              </div>
            </div>
            <div className=" forBackgroundcolor">{/* Blank */}</div>
          </div>
        </div>

        {/***FOOTER */}
        {/**BASIC FOOTER */}

        <div className=" footerLp">
          <div className=" footerContainer">
            <div className=" footerFirstRow">
              <div className=" logoIMg">
                <img
                  width="100%"
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                  alt={logoWhite}
                ></img>
              </div>
              <div className=" footerDesc">
                <p>
                  Redcliffe Labs is an accredited advanced diagnostic laboratory
                  that aims at providing top-notch consistent and accurate
                  laboratory services with modern technology and equipment all
                  inclusive of logistics management.
                </p>
              </div>
            </div>
            <div className=" footerSecondRow">
              <div className=" footerLogo">
                <span>Contact Us</span>
                <div className=" emailLogo">
                  <span>
                    <FiMail />
                  </span>
                  care@redcliffelabs.com
                </div>
                <a href={`tel:+91${footerTel}`}>
                  <div className=" phoneLogo">
                    <span>
                      <FiPhone />
                    </span>
                    {footerTel}
                  </div>
                </a>
              </div>
            </div>
            <div className=" borderDiv"></div>
            <div className=" footerThirdRow">
              <div className=" footerMsg">
                <p>
                  Redcliffe Labs <br /> © 2022. All rights reserved.
                </p>
                <p>
                  Disclaimer: As per "Pre-Natal Diagnostic Techniques
                  (Regulation and prevention of Misuse) Act, 1994", our labs
                  strictly does not determine the sex of the fetus.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/***FIXED FOOTER */}
        {/* <div className=" Lpfooter">
          <div className=" lpfooter__content">
            <form onSubmit={handelSubmit}>
              <div className=" nameInput ">
                Name
                <input
                  type="text"
                  onChange={handelUserName}
                  className={nameError ? "colorRed" : ""}
                  placeholder={nameError ? nameError : "Enter Name"}
                  value={nameError ? () => setUserName("") : userName}
                ></input>
              </div>
              <div className=" phoneInput">
                Phone Number
                <input
                  type="text"
                  className={phoneError ? "colorRed" : ""}
                  placeholder={phoneError ? phoneError : "Enter Phone Number"}
                  value={phoneError ? () => setUserName("") : userNumber}
                  onChange={handelPhoneChange}
                  required
                ></input>
              </div>

              {successBtn ? (
                <div className=" submitButton__lpfooter">
                  <button
                    disabled="disabled"
                    className=" btnSuccess"
                    type="submit"
                  >
                    Success
                  </button>
                </div>
              ) : (
                <div className=" submitButton__lpfooter">
                  <button
                    id="Lpbottom"
                    disabled={nameError || disable ? "disabled" : null}
                    className={nameError || disable ? "disabled" : null}
                    type="submit"
                  >
                    Book Now
                  </button>
                </div>
              )}
            </form>
          </div>
          <button id="MobFotterButton" onClick={scrollTop}>
            Book Now
          </button>
        </div> */}

        {/* Notification popup */}
        <Modal
          classNames={{
            overlay: "customOverlay",
            modal: "notificationPopup_modal",
          }}
          open={open1}
          onClose={onCloseModal1}
          center
        >
          <Popup setOpen={setOpen1} />
        </Modal>

        <ScrolltoTop />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  package: state?.lpPackage?.lpPackageData,
  loading: state?.lpPackage?.loadinglp,
  success: state?.lpPackage?.success,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getLppackageDetails: (lpslug) => {
      dispatch(LpActions.getLppackageDetails(lpslug));
    },
    getCall: (body) => {
      dispatch(LpActions.getCall(body));
    },
  };
};
export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Adlp)),
};
